import { Close32 } from '@carbon/icons-react';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const LightBox = ({
  children,
  mountId,
  onRequestClose
}) => {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);
  const [containerCreated, setContainerCreated] = useState(false);
  useEffect(() => {
    document.body.style.setProperty('overflow', 'hidden');
    ref.current = document.getElementById(mountId);

    if (!ref.current) {
      const container = document.createElement('div');
      container.setAttribute('id', mountId);
      container.style.height = '100%';
      container.style.width = '100%';
      document.querySelector('body').appendChild(container);
      ref.current = container;
      setContainerCreated(true);
    }

    setMounted(true); // Remove created container on component unmount.

    return () => {
      if (ref.current && containerCreated) {
        document.querySelector('body').removeChild(ref.current);
      }
    };
  }, [mountId]);
  useEffect(() => {
    const onKeyDown = evt => {
      if (evt.key === 'Escape') {
        handleClose(evt);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  const handleClose = evt => {
    onRequestClose && onRequestClose();
    setMounted(false);
    evt.stopPropagation();
    document.body.style.overflow = '';
  };

  const element = /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    key: "light-box-container",
    onClick: handleClose,
    className: "om-light-box__back-drop"
  }, /*#__PURE__*/React.createElement("div", {
    key: "light-box-content",
    className: "om-light-box__content",
    onClick: evt => evt.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Close",
    className: "om-light-box__close-btn",
    onClick: handleClose,
    tabIndex: "1"
  }, /*#__PURE__*/React.createElement(Close32, null)), children));
  return mounted ? /*#__PURE__*/createPortal(element, ref.current) : null;
};

LightBox.propTypes = {
  children: PropTypes.element,
  mountId: PropTypes.string,
  onRequestClose: PropTypes.func
};
LightBox.defaultProps = {
  mountId: 'light-box-mount'
};
export { LightBox as Pure };
export default /*#__PURE__*/memo(LightBox);